import ComponentServiceInterface from "./ComponentServiceInterface.ts";
import ComponentNotFoundError from "./exception/ComponentNotFoundError.ts";
import ComponentInterface from "./ComponentInterface.ts";

export default class ComponentService implements ComponentServiceInterface
{
    map: Map<string, ComponentInterface>

    constructor() {
        this.map = new Map<string, ComponentInterface>();
    }

    add(index: string, comp: ComponentInterface): ComponentServiceInterface
    {
        this.map.set(index, comp);

        return this;
    }

    get(index: string): ComponentInterface
    {
        let comp = this.map.get(index);

        if (comp === undefined) {
            throw new ComponentNotFoundError(index);
        }

        return comp;
    }

    has(index: string): boolean
    {
        if (undefined !== this.map.get(index)) {
            return true;
        }

        return false;
    }

    getForLayout(layout: string): Array<ComponentInterface>
    {
        let res = [];

        Array.from(this.map.values()).forEach(v => {
            if ((v.getConfig()['display'] ?? 'CustomModule') === layout) {
                res.push(v.getConfig());
            }
        });

        return res;
    }
}


// WEBPACK FOOTER //
// ./src/services/components/ComponentService.ts